import React from 'react';
import './rupee-input-field.scss';
import {
  getCurrencySign,
  isValidCurrencyAmount,
} from '@zonofi/common/functions/format-amount';

interface RupeeInputFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onInputBlur?: () => void;
  inputWidth?: number;
  inputColor?: string;
  inputHeight?: number;
  disabled?: boolean;
}

export const RupeeInputField: React.FC<RupeeInputFieldProps> = ({
  value,
  onChange,
  placeholder = '',
  onInputBlur,
  inputWidth = 50,
  inputColor = '#000000',
  inputHeight,
  disabled = false,
}) => {
  return (
    <div className="rupee-input-container">
      <span
        className="rupee-input-container-text font-medium"
        style={{ color: inputColor, height: inputHeight }}
      >
        {getCurrencySign()}
      </span>
      <input
        type="number"
        className={`rupee-input-view font-medium ${disabled ? 'disabled' : ''}`}
        style={{
          width: inputWidth,
          height: inputHeight,
          color: disabled ? '#8C8C8C' : inputColor,
        }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          const raw = e.target.value;
          if (isValidCurrencyAmount(raw)) {
            onChange(raw);
          }
        }}
        onBlur={onInputBlur}
        inputMode="numeric"
        disabled={disabled}
      />
    </div>
  );
};
